"use strict";
/**
 * @module Shapes
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 图形
 */
var R_1 = require("../R");
var utils_1 = require("../utils");
var LineShape_1 = require("./LineShape");
var ModifyAbleShape_1 = require("./ModifyAbleShape");
/**
 * 路径
 */
var PathShape = /** @class */ (function (_super) {
    __extends(PathShape, _super);
    function PathShape(paths) {
        var _this = _super.call(this) || this;
        _this.render = function (ctx) {
            R_1.putPath(_this.paths)(ctx);
        };
        _this.setValue(paths);
        return _this;
    }
    PathShape.prototype.moveUp = function (n) {
        this.paths = this.paths.map(function (point) { return [point[0], point[1] + n]; });
    };
    PathShape.prototype.moveDown = function (n) {
        this.paths = this.paths.map(function (point) { return [point[0], point[1] - n]; });
    };
    PathShape.prototype.moveLeft = function (n) {
        this.paths = this.paths.map(function (point) { return [point[0] + n, point[1]]; });
    };
    PathShape.prototype.moveRight = function (n) {
        this.paths = this.paths.map(function (point) { return [point[0] - n, point[1]]; });
    };
    Object.defineProperty(PathShape.prototype, "paths", {
        get: function () {
            return this.valueOf();
        },
        set: function (path) {
            this.setValue(path);
        },
        enumerable: true,
        configurable: true
    });
    PathShape.prototype.inRegion = function (p) {
        var t = utils_1.sliding(2, this.paths);
        return t.some(function (item) { return LineShape_1.LineShape.inRegion(item[0], item[1], p); });
    };
    return PathShape;
}(ModifyAbleShape_1.ModifyAbleShape));
exports.PathShape = PathShape;
//# sourceMappingURL=PathShape.js.map